import React, {useState} from "react";
import swal from "sweetalert";
import axios from "axios";
import {Multipartheader} from "../../Components/Url/ApiUrl";
import {useTranslation} from "react-i18next";

const EditDocuments = ({show, handleClose, onSuccess, data, handleViewFile, user}) => {
    const {t} = useTranslation();
    const [newFiles, setNewFiles] = useState({
        guvohnoma: null,
        soliq_dalolatnoma: null,
        oliy_talim_shartnoma: null,
        ilmiy_hodimlar: null,
        ishlab_chiqarish_sertifikat: null
    });
    const titles = {
        guvohnoma: t('translation:certificate'),
        soliq_dalolatnoma: t('tax_certificate'),
        oliy_talim_shartnoma: t('cooperation_agreement'),
        ilmiy_hodimlar: t('scientists'),
        ishlab_chiqarish_sertifikat: t('certificat')
    }
    const handleFileChange = (field, file) => {
        setNewFiles(prev => ({
            ...prev,
            [field]: file
        }));
    };
    const handleSave = async () => {
        const formData = new FormData();
        for (let key in newFiles) {
            if (newFiles[key]) {
                formData.append(key, newFiles[key]);
            }
        }
        try {
            const res = await axios
                .post(
                    process.env.REACT_APP_API_ENDPOINT + '/company/company-documents',
                    formData,
                    {
                        headers:Multipartheader
                    });
            if (!res.data || !res.data?.success) {
                const message = res.data?.message;
                let firstError = t('translation:saving_error');
                if (message && typeof message === 'object') {
                    const firstKey = Object.keys(message)[0];
                    if (firstKey && Array.isArray(message[firstKey])) {
                        firstError = message[firstKey][0];
                    }
                }else{
                    firstError = res.data?.message;
                }

                swal(t('error'), firstError, "error");
                throw new Error(firstError);
            }
            await swal(t('translation:saved'), `${t('translation:success')} ${t('saved')}`, "success");
            handleClose();
            onSuccess();
        } catch (err) {
            swal(t('translation:error'), err.message || t('translation:unknown_error'), "error");
        }
    }
    const handleValidatedSave = () => {
        const allowedExtension = 'pdf';
        const allowedMimeType = 'application/pdf';
        const maxSize = 10 * 1024 * 1024;
        let has_file = 0
        for (let key in newFiles) {
            const file = newFiles[key];
            if (file) {
                has_file++;
                const extension = file.name.split('.').pop().toLowerCase();
                if (extension !== allowedExtension) {
                    document.getElementById(key).classList.add('border-danger')
                    swal(t('error'),t('pdf_req',{file_title: titles[key]}),'warning');
                    return false;
                }
                if (file.type !== allowedMimeType) {
                    document.getElementById(key).classList.add('border-danger')
                    swal(t('error'),t('mime_error',{file_title:titles[key], file_type:file.type}),'warning');
                    return false;
                }
                if (file.size > maxSize) {
                    document.getElementById(key).classList.add('border-danger')
                    swal(t('error'),t('over_size',{file_title: titles[key]}),'warning');
                    return false;
                }
            }
        }
        if(!has_file > 0){
            swal(t('error'), t('no_file_choosen'),'warning')
        }
        handleSave();
    };

    return (
        <div
            className={`modal fade ${show ? "show" : ""}`}
            id="editModal"
            tabIndex="-1"
            aria-labelledby="editModalLabel"
            style={{display: show ? "block" : "none", background: "rgba(0, 0, 0, 0.65)"}}
        >
            <div className="modal-dialog" style={{maxWidth: "1000px"}}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="editModalLabel">
                            {t('edit_information')}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={handleClose}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group mb-3">
                                        <label className="form-label">
                                            {t('registered_cerificate')}:
                                        </label>
                                        <div className="row">
                                            <div className="col-3">
                                                {data.guvohnoma ? (
                                                    <button className="btn btn-link p-0"
                                                            onClick={() => handleViewFile(data.guvohnoma)}>
                                                        {t('certificate')} <i className="bi bi-file-pdf"></i>
                                                    </button>
                                                ) : (
                                                    'Fayl yuklanmagan'
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <input type="file" id="guvohnoma"
                                                       accept="application/pdf" className="form-control"
                                                       onChange={e => handleFileChange('guvohnoma', e.target.files[0])}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div className="col-12">
                                    <div className="form-group mb-3">
                                        <label className="form-label">
                                            {t('comparative_tax_certificate')}:
                                        </label>
                                        <div className="row">
                                            <div className="col-3">
                                                {data.soliq_dalolatnoma ? (
                                                    <button className="btn btn-link p-0"
                                                            onClick={() => handleViewFile(data.soliq_dalolatnoma)}>
                                                        {t('tax_certificate')} <i className="bi bi-file-pdf"></i>
                                                    </button>
                                                ) : (
                                                    t('translation:file_not_uploaded')
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <input type="file" id="soliq_dalolatnoma"
                                                       accept="application/pdf" className="form-control"
                                                       onChange={e => handleFileChange('soliq_dalolatnoma', e.target.files[0])}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div className="col-12">
                                    <div className="form-group mb-3">
                                        <label className="form-label">
                                            {t('cooperation_with_education_long')}
                                        </label>
                                        <div className="row">
                                            <div className="col-3">
                                                {data.oliy_talim_shartnoma ? (
                                                    <button className="btn btn-link p-0"
                                                            onClick={() => handleViewFile(data.oliy_talim_shartnoma)}>
                                                        {t('translation:agreement')} <i className="bi bi-file-pdf"></i>
                                                    </button>
                                                ) : (
                                                    t('translation:file_not_uploaded')
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <input type="file" id="oliy_talim_shartnoma"
                                                       accept="application/pdf" className="form-control"
                                                       onChange={e => handleFileChange('oliy_talim_shartnoma', e.target.files[0])}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div className="col-12">
                                    <div className="form-group mb-3">
                                        <label className="form-label">
                                            {t('scientists_long')}
                                        </label>
                                        <div className="row">
                                            <div className="col-3">
                                                {data.ilmiy_hodimlar ? (
                                                    <button className="btn btn-link p-0"
                                                            onClick={() => handleViewFile(data.ilmiy_hodimlar)}>
                                                        {t('scientists_short')} <i className="bi bi-file-pdf"></i>
                                                    </button>
                                                ) : (
                                                    t('translation:file_not_uploaded')
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <input type="file" id="ilmiy_hodimlar"
                                                       accept="application/pdf" className="form-control"
                                                       onChange={e => handleFileChange('ilmiy_hodimlar', e.target.files[0])}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div className="col-12">
                                    <div className="form-group mb-3">
                                        <label className="form-label">
                                            {
                                                user.production ?
                                                    t('local_production_certificate')
                                                    :t('official_dillership_certificate')
                                            }

                                        </label>
                                        <div className="row">
                                            <div className="col-3">
                                                {data.ishlab_chiqarish_sertifikat ? (
                                                    <button className="btn btn-link p-0"
                                                            onClick={() => handleViewFile(data.ishlab_chiqarish_sertifikat)}>
                                                        {t('certificat')} <i className="bi bi-file-pdf"></i>
                                                    </button>
                                                ) : (
                                                    t('translation:file_not_uploaded')
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <input type="file" id="ishlab_chiqarish_sertifikat"
                                                       accept="application/pdf" className="form-control"
                                                       onChange={e => handleFileChange('ishlab_chiqarish_sertifikat', e.target.files[0])}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            {t('translation:cancel')}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleValidatedSave}>
                            {t('save')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default EditDocuments